import React, { useEffect } from "react";
import logo from "../resources/images/logo.png";
import ConnectingButtons from "./ConnectingButtons";
import { connect } from "react-redux";
import { setIsRoomHost } from "../store/actions";
import { useHistory } from "react-router-dom";

import "./IntroductionPage.css";

const IntroductionPage = ({ setIsRoomHostAction }) => {
  const history = useHistory();

  useEffect(() => {
    // localStorage.removeItem("roomId");

    // setIsRoomHostAction(true); // Set the user as a host
    // history.push("/join-room?host=true"); // Redirect to host meeting page
  }, []);

  return (
    <div className="introduction_page_container">
      <div className="introduction_page_panel">
        <img src={logo} className="introduction_page_image" alt="Logo"></img>
        <ConnectingButtons setIsRoomHostAction={setIsRoomHostAction} />
      </div>
    </div>
  );
};

const mapActionsToProps = (dispatch) => {
  return {
    setIsRoomHostAction: (isRoomHost) => dispatch(setIsRoomHost(isRoomHost)),
  };
};

export default connect(null, mapActionsToProps)(IntroductionPage);
